// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-inline-item[data-v-02e7d512]{display:inline-block;margin-top:.25rem}@media(min-width: 576px){.list-inline-item[data-v-02e7d512]{display:none}}.list-inline-item.list-inline-item-desktop[data-v-02e7d512]{display:none}@media(min-width: 576px){.list-inline-item.list-inline-item-desktop[data-v-02e7d512]{display:inline-block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
